<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="450"
    >
      
      <v-card>
        <p class="text-h5 pa-4 red--text">
          Do not resusitate, this is an important decision! We believe you have discussed with your doctor
        </p>
        <v-card-text class="text-body-1">       
By selecting OK, I understand DNR means that if my heart stops beating or if I stop
breathing, no medical procedure to restart breathing or heart functioning
will be instituted.
I understand this decision will not prevent me from obtaining other
emergency medical care by health care professionals prior to my death.

I hereby agree to the ‘Do Not Resuscitate’ (DNR) order.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    dialog: false
  }),
  methods: {
    openDialog(){
      this.dialog = true
    }
  }
}
</script>

<style>

</style>